<template>
  <a-dialog v-model="show" scrollable max-width="1000px" persistent>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ $t("agenda.lblCheckStatus") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="show = false" />
        </v-toolbar>
      </v-banner>

      <v-card-text>
        <v-container style="padding: 0 !important">
          <a-data-table
            :headers="headers"
            :items="items"
            dense
            :no-data-text="$t('noData')"
            :no-results-text="$t('emptySearchRecords')"
          >
            <template v-slot:item.status="{ item }">
              <v-chip small :color="getFilterStatusColor(item)" dark>
                {{ getFilterStatusLable(item.status) }}
              </v-chip>
            </template>
            <template v-slot:item.request_datetime="{ item }">
              {{ formatDate(new Date(item.request_datetime)) }}
            </template>
            <template v-slot:item.signing_datetime="{ item }">
              {{
                item.signing_datetime
                  ? formatDate(new Date(item.signing_datetime))
                  : ""
              }}
            </template>
          </a-data-table>
        </v-container>
      </v-card-text>
    </v-card>
  </a-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatDate } from "@/utils/util";
export default {
  name: "CheckSignerStatus",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingId: String,
    signingInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    headers() {
      let columns = [
        {
          text: this.$t("search.fileName"),
          align: "start",
          value: "document_name",
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblSignerName"),
          value: "signerName",
          align: "start",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblEmailAddress"),
          value: "email",
          align: "start",
          class: "header header-text",
        },
        // {
        //   text: "Routing order",
        //   value: "routingOrder",
        //   class: "header header-text",
        // },
        {
          text: this.$t("activity.status"),
          value: "status",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblDateSign"),
          value: "signing_datetime",
          sortable: false,
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblDateRequest"),
          value: "request_datetime",
          sortable: false,
          class: "header header-text",
        },
      ];
      return columns;
    },
    items() {
      return this.signingInfo.map((signer) => {
        const user = this.userList.find(
          (user) =>
            String(user.registered_email).toLowerCase() ===
            String(signer.email).toLowerCase()
        );
        return {
          ...signer,
          signerName:
            user && user.firstName
              ? `${user.firstName} ${user.lastName}`
              : signer.email,
          id: user ? user.id : "",
          firstName: user ? user.firstName : "",
          lastName: user ? user.lastName : "",
          profilePhoto: user ? user.profilePhoto : "",
          title: user ? user.title : "",
        };
      });
    },
  },
  methods: {
    ...mapActions({
      momSignatureDocumentStatus: "agenda/momSignatureDocumentStatus",
    }),
    getFilterStatusColor,
    getFilterStatusLable,
    formatDate,
  },
};

function getFilterStatusLable(status) {
  //   1:Unopened
  // 2:Opened (not signed)
  // 3:Returned
  // 99:Signed
  if (status === "99") {
    return this.$t("agenda.lblSigned");
  }
  if (status === "2") {
    return this.$t("agenda.lblNotSigned");
  }
  if (status === "3") {
    return this.$t("agenda.lblReturned");
  }
  if (status === "1") {
    return this.$t("agenda.lblUnopened");
  }
  return this.$t("agenda.lblUnopened");
}

function getFilterStatusColor(item) {
  //   1:Unopened
  // 2:Opened (not signed)
  // 3:Returned
  // 99:Signed
  if (item.status === "99") {
    return "success";
  }
  if (item.status === "2") {
    return "error";
  }
  if (item.status === "3") {
    return "warning";
  }
  if (item.status === "1") {
    return "warining";
  }
  return "error";
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>